import { useIdentityContext } from '@flik/shared';
import { useTheme } from '@flik/shared/components';
import React from 'react';
import DashboardPage from './DashboardPage';
import LandingPage from './LandingPage';

const HomePage: React.FC = () => {
  const { isLoggedIn, isLoading } = useIdentityContext();
  const { provideTailwind } = useTheme();

  // Show loading screen while authentication state is being determined
  if (isLoading) {
    return (
      <div
        className={`w-full min-h-screen flex items-center justify-center ${provideTailwind(
          'bg-primary',
        )}`}
      >
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-600 mx-auto mb-4"></div>
          <p className={`text-lg ${provideTailwind('text-primary')}`}>
            Loading...
          </p>
        </div>
      </div>
    );
  }

  return isLoggedIn ? <DashboardPage /> : <LandingPage />;
};

export default HomePage;
